var bookshelf = require("../index-extended");
require("./Recipient");

module.exports = bookshelf.model("Recipient", {
  entityName: "Recipient",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "recipient",
  recipients() {
    return this.hasMany("Recipient");
  },
});
